import { ILoggedCustomer } from "api/types";
import { ApolloClient } from "apollo-boost";
import { AppStateContext } from "AppState";
import Button from "components/common/Button/Button";
import Container from "components/common/Grid/Container";
import NumPad, { MediumCenteredNumPad } from "components/common/NumPad";
import RightLeftLayout from "components/common/RightLeftLayout/RightLeftLayout";
import Title from "components/common/Title";
import Widget from "components/common/Widget";
import { CustomerDataContext } from "components/Gates/CustomerDataGate";
import PromoCodeInput, { IPromoCode } from "components/PromoCode";
import * as React from "react";
import { ApolloConsumer } from "react-apollo";
import { Col, Row } from "react-grid-system";
import { Routes } from "router";
import styled from "styled-components";
import { validatePromoCode } from "utils/apis";
import { store } from "utils/ConfigLoader";
import getDetailedGraphqlError from "utils/errorHandling";

// TODO: Rename to IProps
export interface IProp {
  history: {
    push: (to: string) => void;
    goBack: () => void;
  };
}

export interface IState {
  promoCode: IPromoCode;
}

class PromoCode extends React.Component<
  IProp & {
    client: ApolloClient<any>;
    loggedCustomer: ILoggedCustomer | undefined;
    locationName: string;
  },
  IState
> {
  constructor(
    props: IProp & {
      client: ApolloClient<any>;
      loggedCustomer: ILoggedCustomer | undefined;
      locationName: string;
    }
  ) {
    super(props);
    this.state = {
      promoCode: {
        code: ""
      }
    };
  }

  public render() {
    const { promoCode } = this.state;
    const { history } = this.props;
    const disabled = promoCode.code.length < 6;
    return (
      <RightLeftLayout
        title={this.props.locationName}
        titleSecondary="Promo Code"
        backButtonHandler={history.goBack}
        centerLeftContent
        leftPanel={
          <div>
            <Title>Enter Promo Code</Title>
            <PromoCodeInput promoCode={promoCode} budtenderFacing focused />

            <ButtonWrapper>
              <Button
                onClick={this.usePromoCode}
                primary
                disabled={disabled}
                style={{ width: "30vh" }}
              >
                Use Promo Code
              </Button>
            </ButtonWrapper>
          </div>
        }
        rightPanel={
          <MediumCenteredNumPad>
            <NumPad onTap={this.onTap} />
          </MediumCenteredNumPad>
        }
      />
    );
  }

  private onTap = (value: string) => {
    this.setState((state: IState) => {
      const code =
        value === "back"
          ? state.promoCode.code.slice(0, state.promoCode.code.length - 1)
          : `${state.promoCode.code}${value}`.slice(0, 6);

      if (code.length >= 6) {
        this.validatePromoCode(code);
      }

      return {
        promoCode: {
          code
        }
      };
    });
  };

  private validatePromoCode = async (code: string) => {
    const authToken = this.props.loggedCustomer
      ? this.props.loggedCustomer.authToken
      : "";
    try {
      const result = await validatePromoCode(
        this.props.client,
        authToken,
        code
      );
      if (result) {
        this.setState({
          promoCode: {
            code,
            valid: true,
            invalid: false,
            name: result.name
          }
        });
      } else {
        this.setState({
          promoCode: {
            code,
            invalid: true,
            name: "This Code is not Valid"
          }
        });
      }
    } catch (e) {
      console.error(e);
      let errorName = "This Code is not Valid";
      if (e.graphQLErrors && e.graphQLErrors.length > 0) {
        errorName = getDetailedGraphqlError(e.graphQLErrors);
      }

      this.setState({
        promoCode: {
          code,
          invalid: true,
          name: errorName
        }
      });
    }
  };

  private usePromoCode = () => {
    store("purchase.promoCode", this.state.promoCode.code);
    this.props.history.push(Routes.CompletePurchase);
  };
}

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 10vh;
`;

// export default withApollo(PromoCode);

export default (props: IProp) => (
  <ApolloConsumer>
    {client => (
      <CustomerDataContext.Consumer>
        {loggedCustomer => (
          <AppStateContext.Consumer>
            {([appState]) => (
              <PromoCode
                client={client}
                loggedCustomer={loggedCustomer}
                locationName={appState.locationName}
                {...props}
              />
            )}
          </AppStateContext.Consumer>
        )}
      </CustomerDataContext.Consumer>
    )}
  </ApolloConsumer>
);



// WEBPACK FOOTER //
// ./src/screens/PromoCode.tsx